if (!customElements.get('product-navigate')) {
    customElements.define("product-navigate", class ProductNavigate extends HTMLElement {
        constructor() {
            super()
            this.curScrollY = 0
            this.header = document.querySelector('.shopify-section-group-header-group.shopify-section--header')
            this.announcementBar = document.querySelector('.shopify-section-group-header-group.header-announcement--container')
            this.productNavigate = document.querySelector('.shopify-section.product-navigate-sticky')
            this.listenerAnchor()
            this.listenerScroll()
            this.init()
        }

        init() {
            const btn = this.querySelector('.product-navigate-select-btn')
            this.querySelector('.product-navigate-content').addEventListener("click", () => {
                if (this.isMobile()) {
                    this.querySelector('.product-navigate-item-content').classList.toggle('open')
                    btn.classList.toggle('open')
                }

            })
        }

        isMobile() {
            return this.getBrowserWidth() <= 900
        }

        getBrowserWidth() {
            return (
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth
            );
        }

        listenerAnchor() {
            const _this = this
            const navigateItems = this.querySelectorAll('.product-navigate-item')
            navigateItems.forEach((item, index) => {
                let anchor = document.getElementById(item.dataset.anchorId)
      
                if (!anchor && index !== 0) {
                    item.style.display = 'none'
                    return
                }
                item.addEventListener("click", () => {
                    $(navigateItems).not(item).removeClass("active");
                    item.classList.add("active");
                    // let anchor = document.getElementById(item.dataset.anchorId)
                    let scrollTop = 0
                    let headerHeight = _this.header?.clientHeight || 0 
                    let announcementBarHeight = _this.announcementBar?.clientHeight || 0
                    let productNavigateHeight = _this.productNavigate?.clientHeight || 0
                    if (anchor) {
                        scrollTop = anchor.offsetTop + _this.calc(anchor.parentElement) -
                        headerHeight - announcementBarHeight - productNavigateHeight
                    }
                    $("html, body").animate({
                        scrollTop
                    },
                        500
                    );
                })
            })

        }
        listenerScroll() {
            window.addEventListener("scroll", () => {
                if (this.getScrollTop() > this.announcementBar.clientHeight) {
                    this.updateElementTopValue()
                }

            })
        }
        updateElementTopValue() {
            if (this.isScrollDown()) {
                this.productNavigate.style.top = 0
                this.header.style.top = `-${this.header.clientHeight}px`
            } else {
                this.header.style.top = 0
                this.productNavigate.style.top = `${this.header.clientHeight}px`
            }
        }
        isScrollDown() {
            const scrollY = this.getScrollTop();
            let delta = scrollY - this.curScrollY;
            this.curScrollY = scrollY
            return delta > 0;
        }
        getScrollTop() {
            return (
                document.documentElement.scrollTop ||
                document.body.scrollTop ||
                window.scrollY ||
                0
            );
        }
        calc(dom, distance) {
            distance = distance || 0;
            if (
                ["relative", "absolute", "fixed"].includes(getComputedStyle(dom).position)
            ) {
                distance += distance.offsetTop;
            }
            if (dom.parentElement.nodeName === "BODY" || !dom.parentElement) {
                return distance;
            }
            return this.calc(dom.parentElement, distance);
        }
    })
}